import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
import NothingToDeclareData from "../../data/nothing-to-declare.data";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    fontFamily: "Helvetica",
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 50,
    paddingRight: 50,
    lineHeight: 1.5,
    flexDirection: "column",
  },
  logo: {
    width: 84,
    height: 70,
    marginLeft: "auto",
    marginRight: "auto",
  },
  titleContainer: {
    marginTop: 24,
  },
  reportTitle: {
    color: "#3778C2",
    letterSpacing: 4,
    fontSize: 25,
    textAlign: "center",
    textTransform: "uppercase",
  },
  reportDescription: {
    fontSize: 12,
    marginBottom: 10,
  },
  row: {
    flexDirection: "column",
    borderBottomWidth: 1,
    fontSize: 12,
    fontStyle: "bold",
  },
  description: {
    width: "100%",
  },
  total: {
    width: "100%",
  },
});

export type updateNothingToDeclareTypes = {
  formData: {
    month: string;
    comment: string;
    printmonth: boolean;
    printcomment: boolean;
  };
};

export const NothingToDeclarePDF = ({
  formData,
}: updateNothingToDeclareTypes) => {
  const { t } = useTranslation();
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.titleContainer}>
          <Text style={styles.reportTitle}>
            {t(NothingToDeclareData.title)}
          </Text>
          <Text style={styles.reportDescription}>
            {t(NothingToDeclareData.description.i18nKey)}
          </Text>
        </View>
        {NothingToDeclareData.fields.map((field, index) => {
          if (field.name === "month" && formData["printmonth"]) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.name)}</Text>
                <Text style={styles.description}>{t(formData["month"])}</Text>
              </View>
            );
          } else if (field.name === "comment" && formData["printcomment"]) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.name)}</Text>
                <Text style={styles.description}>{t(formData["comment"])}</Text>
              </View>
            );
          }
          return null;
        })}
      </Page>
    </Document>
  );
};
